export default {
	"videoPlayer.cta": "Video öffnen",
	"videoPlayer.alt": 'Standbild aus Video "{name}"',
} as const;
